import { Grid, Hidden } from "@material-ui/core";
import clsx from "clsx";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import useBreakpoint from "../../hooks/useBreakpoint";
import useRegisterExit from "../../hooks/useRegisterExit";
import { useStore } from "../../hooks/useStore";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import useValidation from "../../hooks/useValidation";
import {
  loadingScanPeopleInside,
  loadingSearchPeopleInside,
} from "../../redux/actions/registerExitActions";
import ManualSearchForm from "../../shared/ManualSearchForm/ManualSearchForm";
import { ISearchUser } from "../../store/types/userTypes";
import Dialog from "../common/Dialog";
import SubmitButton from "../common/SubmitButton";
import { Title } from "../common/Title";
import Scan from "../Scan/Scan";
import RegisterExitData from "./RegisterExitData/RegisterExitData";
import RegisterExitDataMobile from "./RegisterExitDataMobile/RegisterExitDataMobile";
import RegisterExitSearch from "./RegisterExitSearch/RegisterExitSearch";
import { useStyles } from "./RegisterExitStyles";

const RegisterExit = () => {
  const classes = useStyles();
  const [openDialogSearch, setOpenDialogSearch] = useState(false);
  const [openDialogScan, setOpenDialogScan] = useState(false);
  const { t, BundleKey } = useTranslation();
  const { searchExit } = useRegisterExit();
  const { registerExitStore } = useStore();
  const { isMobile } = useBreakpoint();
  const dispatch = useDispatch();
  const { isLoadUserTab } = useValidation();
  const { autoChangeTab } = useTabs();

  const closeDialogSearch = () => {
    setOpenDialogSearch(false);
  };

  const submitDialogSearch = (dni: string, countryCode: string) => {
    isLoadUserTab({ dni, countryCode }).then((response) => {
      if (response.isLoad) {
        autoChangeTab(response.tabIndex);
      } else {
        dispatch(loadingSearchPeopleInside(true));
        searchExit({ dni, countryCode });
        closeDialogSearch();
      }
    });
  };

  const openScanDialog = () => {
    setOpenDialogScan(true);
  };

  const openSearchDialog = () => {
    setOpenDialogSearch(true);
  };

  const closeDialogScan = () => {
    setOpenDialogScan(false);
  };

  const submitDialogScan = (search: ISearchUser) => {
    isLoadUserTab(search).then((response) => {
      if (response.isLoad) {
        autoChangeTab(response.tabIndex);
      } else {
        dispatch(loadingScanPeopleInside(true));
        searchExit(search);
        setOpenDialogScan(false);
      }
    });
  };

  return (
    <div className={classes.root}>
      <Title>{t(BundleKey.REGISTEREXIT_TITLE)}</Title>
      <div className={classes.grid}>
        <RegisterExitSearch />
        <>
          <Hidden smDown>
            <RegisterExitData />
          </Hidden>
          <Hidden mdUp>
            <RegisterExitDataMobile />
          </Hidden>
        </>
        <Grid
          container
          justifyContent="flex-end"
          className={clsx(classes.containerGrid, {
            [classes.sticky]: isMobile,
          })}
        >
          <Grid item xs={6} md={4} className={classes.spacing}>
            <SubmitButton
              color="primary"
              size="large"
              className={isMobile ? classes.buttonSticky : ""}
              onClick={openSearchDialog}
              loading={registerExitStore.loadingSearch}
            >
              {t(BundleKey.REGISTEREXIT_ACTION_MANUAL)}
            </SubmitButton>
          </Grid>
          <Grid item xs={6} md={4} className={classes.spacing}>
            <SubmitButton
              color="primary"
              size="large"
              className={isMobile ? classes.buttonSticky : ""}
              onClick={openScanDialog}
              loading={registerExitStore.loadingScan}
            >
              {t(BundleKey.REGISTEREXIT_ACTION_SCAN)}
            </SubmitButton>
          </Grid>
        </Grid>
        <Dialog open={openDialogSearch} onClose={closeDialogSearch}>
          <ManualSearchForm
            onSubmit={submitDialogSearch}
            onCancel={closeDialogSearch}
          />
        </Dialog>
        <Dialog
          open={openDialogScan}
          onClose={closeDialogScan}
          fullScreen
          title={t(BundleKey.DETAIL_COMPATION_SCAN)}
        >
          <Scan onScan={submitDialogScan} />
        </Dialog>
      </div>
    </div>
  );
};

export default RegisterExit;
